function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Plan-Recommender",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Plan-Rec-Results-PPO",
  transform: "translate(-950.000000, -345.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "badge-3",
  transform: "translate(950.000000, 345.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "recommended-badge"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0610894,0.471 C10.9176596,-0.157 12.0813585,-0.157 12.9389259,0.471 C14.9921016,1.977 14.5503547,1.833 17.0931416,1.825 C18.1551291,1.822 19.0964588,2.508 19.4205395,3.521 C20.1983332,5.948 19.9261054,5.573 21.9882557,7.065 C22.8488146,7.688 23.2087934,8.798 22.8777325,9.81 C22.0859785,12.227 22.0819898,11.763 22.8777325,14.19 C23.2097906,15.201 22.8498117,16.312 21.9882557,16.935 C19.9261054,18.426 20.1993303,18.051 19.4205395,20.479 C19.0964588,21.493 18.1541319,22.179 17.0931416,22.175 C14.5493576,22.167 14.9911045,22.023 12.9389259,23.529 C12.0823557,24.157 10.9186568,24.157 10.0610894,23.529 C8.00791365,22.024 8.44966054,22.166 5.90687365,22.175 C4.84488619,22.178 3.90355645,21.492 3.57947577,20.479 C2.80168213,18.049 3.06992122,18.424 1.01175959,16.935 C0.151200733,16.312 -0.208778117,15.202 0.122282765,14.19 C0.915033972,11.773 0.918025486,12.237 0.122282765,9.81 C-0.209775289,8.797 0.150203562,7.687 1.01076242,7.064 C3.0669297,5.575 2.80068496,5.953 3.5784786,3.52 C3.90255928,2.506 4.84488619,1.82 5.90587648,1.824 C8.44367752,1.832 7.99594759,1.985 10.0610894,0.471 Z",
  id: "badge-1",
  fill: "#28B667",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("text", {
  id: "#3",
  fontFamily: "Lato-Black, Lato",
  fontSize: 11,
  fontWeight: 700,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4.12,
  y: 16
})))));
function SvgIconRankGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankGreen);
export default __webpack_public_path__ + "static/media/icon-rank-green.26920ba7.svg";
export { ForwardRef as ReactComponent };